export const TO = {
  ROOT: '/',
  LOGIN: '/login',
  SIGN_UP: '/sign-up',
  FORGOT_PASSWORD: '/forgot-password',
  ONBOARDING: '/onboarding',
  SUBSCRIBE_STRATEGY: '/subscribe-strategy',
  EDIT_SUBSCRIPTION: '/edit-subscription',
  TERMS_AND_CONDITIONS: '/terms-and-conditions'
}